export const BrandSecretsPaths = {
    list: "",
    create: "create",
    edit: ":id/edit",
} as const;
